<template>
    <div :class="['list-view', showDetail ? 'no-sub-header' : '']">
        <div class="filters">
            <div>
                <div :class="['filter-list-button-large', { active : showDetailTab == 'description' }]" @click="fetchDetailTab('description')">Description Page</div>
                <div :class="['filter-list-button-large', { active : showDetailTab == 'terms' }]" @click="fetchDetailTab('terms')">Terms Page</div>
                <div :class="['filter-list-button-large', { active : showDetailTab == 'complete' }]" @click="fetchDetailTab('complete')">Application Complete</div>
                <button class="button action" @click="saveItem()">Save Page</button>
            </div>
			<div class="divider"></div>
			<div class="extra-menu-item">
				<a :href="getDevEnvironment ? 'https://kiosk.test:9001/kiosk/' : '/kiosk'" target="_blank">Customer Kiosk</a>
			</div>
			<div v-if="legacyLink">
				<router-link :to="legacyLink" class="extra-menu-item">Legacy Version</router-link>
			</div>
        </div>

	    <div class="detail">

		    <div v-if="showDetailTab == 'description'">
                <h2>Membership Description Page</h2>
                <div class="two-one-columns">
                    <p>When your customers apply for a membership online or at your store kiosk, they will see the Membership Description page first. Enter a helpful description of the different membership levels you offer.</p>
                    <!-- <checkbox label="Deactivate Page" v-model="membershipDescription.inactive"/> -->
                </div>
                <ckeditor :editor="editor" :config="editorConfig" v-model="membershipDescription.content"></ckeditor>
            </div>

            <div v-else-if="showDetailTab == 'terms'" class="tab-content">
                <h2>Membership Terms Page</h2>
                <div class="two-one-columns">
                    <p>In order to apply for a membership, your customer will need to agree to all of your membership terms. Make sure to include any rules, terms, and conditions that apply to having a membership.</p>
                    <!-- <checkbox label="Deactivate Page" v-model="membershipTerms.inactive"/> -->
                </div>
                <ckeditor :editor="editor" :config="editorConfig" v-model="membershipTerms.content"></ckeditor>
            </div>

            <div v-else-if="showDetailTab == 'complete'" class="tab-content">
                <h2>Membership Application Complete Page</h2>
                <div class="two-one-columns">
                    <p>Once the customer has finished, they will see the Membership Application Complete page. Let them know they are finished and what happens next in the membership process.</p>
                    <!-- <checkbox label="Deactivate Page" v-model="membershipComplete.inactive"/> -->
                </div>
                <ckeditor :editor="editor" :config="editorConfig" v-model="membershipComplete.content"></ckeditor>
            </div>
        </div>

		<help-popup :helpLink="{399:'Membership Application Pages', 60:'Online Membership Application', 403:'Customer Kiosk', 61:'Online Waivers'}" :tours="false"></help-popup>

        <message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

    </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import List from '@ckeditor/ckeditor5-list/src/list';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import { Undo, Redo } from '@ckeditor/ckeditor5-undo/src/';
import Checkbox from '@/components/Checkbox.vue'
import Loading from '@/components/Loading.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
    name: 'MembershipApplicationPages',
    components: {
        'ckeditor': CKEditor.component,
        'loading': Loading,
		'checkbox': Checkbox,
		'help-popup': HelpPopup
    },
    data () {
        return {
            loading: false,
            message: '',
            messageStatus: '',
            messageTimeout: 0,
            membershipDescription: '',
            membershipTerms: '',
            membershipComplete: '',
			showDetailTab: 'description',
            showDetail: true,
			legacyLink: '',
			editor: ClassicEditor,
			editorConfig: {
                plugins: [
					Alignment,
					Image,
					ImageToolbar,
					ImageCaption,
					ImageStyle,
					ImageResize,
					ImageUpload,
                    Bold,
                    Italic,
					Underline,
                    Link,
                    Paragraph,
					Heading,
					List,
					MediaEmbed,
					Undo
                ],
                toolbar: {
                    items: [
                        'bold',
                        'italic',
						'underline',
						'heading',
						'link',
						'alignment:left',
						'alignment:center',
						'alignment:right',
						'numberedList',
						'bulletedList',
						'imageUpload',
						'mediaEmbed',
                        'undo',
                        'redo',
                    ]
                },
				extraPlugins: [ this.theUploadAdapterPlugin ],
				heading: {
		            options: [
		                { model: 'paragraph', title: 'Paragraph' },
		                { model: 'heading1', view: 'h1', title: 'Heading 1' },
						{ model: 'heading2', view: 'h2', title: 'Heading 2' },
		                { model: 'heading3', view: 'h3', title: 'Heading 3' },
					]
				},
				image: {
		            // You need to configure the image toolbar, too, so it uses the new style buttons.
		            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
		            styles: [
		                // This option is equal to a situation where no style is applied.
		                'full',
		                // This represents an image aligned to the left.
		                'alignLeft',
		                // This represents an image aligned to the right.
		                'alignRight'
		            ]
		        },
				mediaEmbed: {
					removeProviders: [ 'dailymotion', 'spotify', 'instagram', 'twitter', 'googleMaps', 'flickr', 'facebook' ] // 'vimeo', 
				},
				link: {
					decorators: {
						openInNewTab: {
							mode: 'manual',
							label: 'Open in new tab',
							attributes: {
								target: '_blank',
								rel: 'noopener noreferrer' // prevent reverse tabnabbing
							}
						}
					}
				}
            }
        }
    },
	created() {
		this.getList()
	},
    methods: {
        theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
        getList() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_membership_application_pages' }).then(obj => {
				this.loading = false
				if (obj.legacy_link) {
					this.legacyLink = obj.legacy_link
				}
                this.messageStatus = obj.status
				if (obj.status == 'success') {
                    this.membershipDescription = obj.membership_description
                    this.membershipTerms = obj.membership_terms
                    this.membershipComplete = obj.membership_complete
				} else {
                    this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
        },
        fetchDetailTab(detailTab, forceReload = false) {
			if (detailTab == this.showDetailTab) { return }
			this.showDetailTab = detailTab
		},
		saveItem() {
			if (this.saving) { return }
			this.messageStatus = ''
            let whichPage = null
            switch (this.showDetailTab) {
                case 'description':
                    whichPage = this.membershipDescription
                    break
                case 'terms':
                    whichPage = this.membershipTerms
                    break
                case 'complete':
                    whichPage = this.membershipComplete
                    break
            }
			if (!whichPage.content) {
				this.messageStatus = 'invalid'
				this.message = 'Content is required.'
				return false
			}
			this.saving = true
			this.message = 'Saving...'
			this.apiCall({ destination: 'save_item_membership_page', data: whichPage }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Saved!'
					setTimeout(() => {
						this.message = ''
					}, 1500)
				} else {
					this.message = obj.message || 'Error saving membership page.'
				}
			}).catch(err => {
				console.log(err)
			})
		},
    }
}
</script>

<style lang="scss" scoped>
.detail {
    h2, .two-one-columns {
        margin-bottom: 1em;
        column-gap: 2em;
    }
}
</style>